export const scrollToId = (id) => {
  const lenis = window.__chwa_lenis;
  if (lenis) {
    lenis.scrollTo(id, { offset: id === "#top" ? 0 : -56, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
